import { useState, useEffect, useParams, axios, Button, Input, Card, CardContent, CardHeader, CardTitle, CardDescription, Label, Loader2, Check, API, toast } from "@/pages/shared";

export const PublicFormPage = () => {
  const { formId } = useParams();
  const [form, setForm] = useState(null);
  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
  const campaignId = new URLSearchParams(window.location.search).get("cmp") || null;

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/leads/forms/${formId}`);
        setForm(res.data);
        const init = {};
        res.data.fields.forEach(f => init[f] = "");
        setFormData(init);
      } catch (e) {}
      setLoading(false);
    };
    fetch();
  }, [formId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/leads/submit`, { form_id: formId, data: formData, campaign_id: campaignId });
      setSubmitted(true);
      toast.success("Thank you!");
    } catch (e) {
      toast.error("Failed");
    }
    setSubmitting(false);
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-violet-500" /></div>;
  if (!form) return <div className="min-h-screen flex items-center justify-center"><p className="text-muted-foreground">Form not found</p></div>;
  if (submitted) return <div className="min-h-screen flex items-center justify-center hero-glow"><Card className="glass max-w-md w-full mx-4"><CardContent className="p-8 text-center"><div className="w-16 h-16 rounded-full bg-teal-500/20 flex items-center justify-center mx-auto mb-4"><Check className="w-8 h-8 text-teal-500" /></div><h2 className="text-2xl font-bold mb-2">Thank You!</h2></CardContent></Card></div>;

  return (
    <div className="min-h-screen flex items-center justify-center hero-glow px-4">
      <Card className="glass max-w-md w-full">
        <CardHeader><CardTitle>{form.name}</CardTitle>{form.description && <CardDescription>{form.description}</CardDescription>}</CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {form.fields.map((field) => <div key={field}><Label className="capitalize">{field}</Label><Input value={formData[field] || ""} onChange={(e) => setFormData({...formData, [field]: e.target.value})} className="mt-1 bg-white/5 border-white/10" required /></div>)}
            <Button type="submit" disabled={submitting} className="w-full btn-primary-glow bg-violet-600 hover:bg-violet-700 rounded-full">{submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Submit"}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
